export default __webpack_public_path__ + "static/media/q_wdt_c_1_2.474103fc.mp3";